import { render, staticRenderFns } from "./tabYF.vue?vue&type=template&id=3cc85630&scoped=true&"
import script from "./tabYF.vue?vue&type=script&lang=js&"
export * from "./tabYF.vue?vue&type=script&lang=js&"
import style0 from "./tabYF.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabYF.vue?vue&type=style&index=1&id=3cc85630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc85630",
  null
  
)

export default component.exports